import * as actionTypes from "../../Actions/Auth/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  IsLoading: false,
  UserRole: null,
  MustLogin: false,

  User: {
    request: null,
    response: null,
    error: null,
  },

  LoginUser: {
    request: null,
    response: null,
    error: null,
  },

  checkUserName: {
    request: null,
    response: null,
    error: null,
  },

  loginByKey: {
    request: null,
    response: null,
    error: null,
  },

  HelpicalToken: {
    request: null,
    response: null,
    error: null,
    laoding: false
  },
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.TOGGLE_LOADING:
      return { ...state, IsLoading: action.loading };

    case actionTypes.CLEAR_AUTH_STATE:
      return { ...state, [action.state]: initialState[action.state] };

    case actionTypes.USER_MUST_LOGIN:
      return actionReducer.userMustLogin(state, action);

    case actionTypes.GET_CURRENT_USER:
      return actionReducer.getCurrentUser(state, action);
    case actionTypes.GET_CURRENT_USER_SUCCESS:
      return actionReducer.getCurrentUserSuccess(state, action);
    case actionTypes.GET_CURRENT_USER_FAIL:
      return actionReducer.getCurrentUserFail(state, action);

    case actionTypes.LOGIN_USER:
      return actionReducer.loginUser(state, action);
    case actionTypes.LOGIN_USER_SUCCESS:
      return actionReducer.loginUserSuccess(state, action);
    case actionTypes.LOGIN_USER_FAIL:
      return actionReducer.loginUserFail(state, action);

    case actionTypes.CHECK_USERNAME_EXIST:
      return actionReducer.checkUserName(state, action);
    case actionTypes.CHECK_USERNAME_EXIST_SUCCESS:
      return actionReducer.checkUserNameSuccess(state, action);
    case actionTypes.CHECK_USERNAME_EXIST_FAIL:
      return actionReducer.checkUserNameFail(state, action);

    case actionTypes.LOGIN_USER_BY_KEY:
      return actionReducer.loginUserByKey(state, action);
    case actionTypes.LOGIN_USER_BY_KEY_SUCCESS:
      return actionReducer.loginUserByKeySuccess(state, action);
    case actionTypes.LOGIN_USER_BY_KEY_FAIL:
      return actionReducer.loginUserByKeyFail(state, action);

    case actionTypes.GET_HELPICAL_TOKEN:
      return actionReducer.getHelpicalTokenKey(state, action);
    case actionTypes.GET_HELPICAL_TOKEN_SUCCESS:
      return actionReducer.getHelpicalTokenKeySuccess(state, action);
    case actionTypes.GET_HELPICAL_TOKEN_FAIL:
      return actionReducer.getHelpicalTokenKeyFail(state, action);

    default:
      return state;
  }
};

export { AuthReducer };